<template>
  <div class="has-background-white container">
    <div
      class="card margin-top-minus-40 has-margin-left-15-mobile has-margin-right-15-mobile rounded-10 pa-5 is-shadowless has-margin-left-60-desktop has-margin-right-60-desktop"
    >
      <slider></slider>
      <div class="columns mt-3">
        <div class="column is-4">
          <div
            class="outline column is-11 box is-shadowless has-padding-right-10-mobile has-padding-left-10-mobile"
          >
            <category></category>
            <archive></archive>
            <blog-tag></blog-tag>
          </div>
        </div>
        <div class="column is-8 has-margin-top-10-mobile">
          <blog-list></blog-list>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Category from '@/components/Blog/Category'
import Archive from '@/components/Blog/Archive'
import BlogTag from '@/components/Blog/Tag'
import BlogList from '@/components/Blog/BlogList'
import Slider from '@/components/Blog/Slider'

export default {
  components: { Category, BlogList, Slider, BlogTag, Archive }
}
</script>
